module.exports = __webpack_public_path__ + "2aac949a9879e743f2fcbe631e7a7372.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/integrityvikingfunds.png
// module id = 1804
// module chunks = 0